import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../../Vas';

import '../../css/Account.css';

import { ExtendedButton,TextField,Icon,Loading,ConfirmBox } from 'component-lib';
import { DateTimeHelper,TranslateGender } from 'utils-lib';
import { AccountsModel, RequestAjaxClass } from 'models-lib';

var moment = require('moment');
moment().format();
class Account extends Component
{
    constructor(props){
        super(props);
        this.state = {};
        this.Request =  new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.AccountsModel = new AccountsModel([this],null,this.Request);

        this.AccountConfig = Vas.Config.Account;
    }

    componentWillMount(){
        ReactDOM.render(<Loading modal={true} />,document.getElementById('messageContainer'));
    }

    componentDidMount(){
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setAuth(true);

        this.AccountsModel.Own();
        $("#HeaderTitle").html(Vas.Resources.Menus["Account"]);
        ReactDOM.unmountComponentAtNode(document.getElementById('messageContainer'));

        this.LogoClick();

        this.FontSizeClick();
    }

    Update(observer){
      let me = this;
      this.setState({},()=>{
        if(observer === "AccountsOwn"){
          let data = me.AccountsModel.Customer;
          if (me.refs){
            me.refs.CustomerNumber.setState({ Value:data.CustomerNumber });
             me.refs.Name.setState({ Value:data.Name1 });
             me.refs.FirstName.setState({ Value:data.Name2 });
             me.refs.Gender.setState({ Value:TranslateGender.Translate(data.Gender,localStorage.getItem('vas_language'))  });
             me.refs.DateOfBirth.setState({ Value:DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(data.DateOfBirth,true,localStorage.getItem("vas_language"))) });
             me.refs.Street.setState({ Value:data.Street });
             me.refs.HouseNumber.setState({ Value:data.HouseNumber });
             me.refs.Zip.setState({ Value:data.PostCode });
             me.refs.Place.setState({ Value:data.City });
          } 
        }
        else if( observer === "DeleteAccountsOwn"){
          ReactDOM.unmountComponentAtNode(document.getElementById('messageContainer'));
            me.AccountsModel.clearLocalStorage();
            window.location = Vas.ApplicationUrl;
        }
      })
    }
    showChangePassword(){
      Vas.GetView("ChangePassword",null,true);
    }

    Delete(){
      ReactDOM.render(<Loading modal={true} />,document.getElementById('messageContainer'));
      //Löschen des Accounts
      this.AccountsModel.DeleteAccountOwn();
    }

    LogoClick(){

      var kontrastNumber = localStorage.getItem('Kontrast');

      if(kontrastNumber == "true"){
        $(".accountForm #btoChangePassword").attr('style', 'width: 170px; background-color: #1d5c87;');
        $(".accountForm #btoDeleteAccount").attr('style', 'width: 170px; background-color: #1d5c87;');
        $('.accountForm').attr('style', 'border: 1px solid #1d5c87;');
        $('#MessageBoxHeader').attr('style', 'background-color: #1d5c87;');
        $('#MessageBox').attr('style', 'box-shadow: 10px 10px 15px #1d5c87;');
        $('#MessageBox .extendedButton').attr('style', 'width: 150px; float: right; background-color: #1d5c87;');
      }
    }

    FontSizeClick(){
      var schriftgröße = localStorage.getItem('Schriftgröße');
      let role = localStorage.getItem("vas_role");
      //Schriftgröße bei Klick in 2er Schritten erhöhen

        if(schriftgröße != null){
            
              switch(schriftgröße){
                case "0":
                  $("#MessageBoxHeader").removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                  $(".ConfirmBoxMessageContainer").removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                  $('#MessageBox > div:nth-child(3) > div:nth-child(1) > button:nth-child(1)').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                  $('#MessageBox > div:nth-child(4) > div:nth-child(1) > button:nth-child(1)').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                break;
                case "1":
                  $("#MessageBoxHeader").removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                  $(".ConfirmBoxMessageContainer").removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                  $('#MessageBox > div:nth-child(3) > div:nth-child(1) > button:nth-child(1)').removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                  $('#MessageBox > div:nth-child(4) > div:nth-child(1) > button:nth-child(1)').removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                break;
                case "2":
                  $("#MessageBoxHeader").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $(".ConfirmBoxMessageContainer").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $('#MessageBox > div:nth-child(3) > div:nth-child(1) > button:nth-child(1)').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $('#MessageBox > div:nth-child(4) > div:nth-child(1) > button:nth-child(1)').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                break;
                case "3":
                  $("#MessageBoxHeader").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $(".ConfirmBoxMessageContainer").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $('#MessageBox > div:nth-child(3) > div:nth-child(1) > button:nth-child(1)').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $('#MessageBox > div:nth-child(4) > div:nth-child(1) > button:nth-child(1)').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                break;
                case "4":
                  $("#MessageBoxHeader").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $(".ConfirmBoxMessageContainer").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $('#MessageBox > div:nth-child(3) > div:nth-child(1) > button:nth-child(1)').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $('#MessageBox > div:nth-child(4) > div:nth-child(1) > button:nth-child(1)').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                break;
                case "5":
                  $("#MessageBoxHeader").removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                  $(".ConfirmBoxMessageContainer").removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                  $('#MessageBox > div:nth-child(3) > div:nth-child(1) > button:nth-child(1)').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                  $('#MessageBox > div:nth-child(4) > div:nth-child(1) > button:nth-child(1)').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                break;
              }
        }
    }

    render(){

      let button = '';
      if (this.AccountConfig.DeleteAccount === true)
      {
          button = (<ExtendedButton
            Id={"btoDeleteAccount"}
            Usable={true}
            Width={170}
            className={"changePwdButton"}
            Text={Vas.Resources.Labels["DropAccount"]} 
            OnClick={()=>{ ReactDOM.render(<ConfirmBox
              AppURL={Vas.ApplicationUrl}
              LabelConfirm={Vas.Resources.Labels["Confirm"]}
              LabelCancel={Vas.Resources.Labels["Cancel"]}
              modal={true}
              MessageText={Vas.Resources.Labels["ConfirmDeleteAccount"]}
              Click={()=>{this.Delete(); }} /> , document.getElementById('messageContainer')); this.LogoClick(); this.FontSizeClick(); }}  />);
      } 
        
        return (
          <div className={"form accountForm"}>
            <div>
                <div className={"accountDataContainer"}>
                  <div className={"accountDataContainerLarge"}>
                    <Icon
                      Name={"Account"}
                      Size={48}
                      Color={"black"}
                      Align={"left"} />
                  </div>
                  <div className={"accountDataContainerSmall"}>
                    <TextField
                    AppURL={Vas.ApplicationUrl}
                    Label={Vas.Resources.Labels["CustomerNumber"]}
                    ref={"CustomerNumber"} />
                  </div>
                </div>
                <div className={"accountDataContainer"}>
                  <div className={"accountDataContainerLarge"}>
                    <TextField
                    AppURL={Vas.ApplicationUrl}
                    Label={Vas.Resources.Labels["Name"]}
                    ref={"Name"} />
                  </div>
                  <div className={"accountDataContainerSmall"}>
                    <TextField
                    AppURL={Vas.ApplicationUrl}
                    Label={Vas.Resources.Labels["FirstName"]}
                    ref={"FirstName"} />
                  </div>
                </div>
                <div className={"accountDataContainer"}>
                  <div className={"accountDataContainerLarge"}>
                    <TextField
                    AppURL={Vas.ApplicationUrl}
                    Label={Vas.Resources.Labels["Gender"]}
                    ref={"Gender"} />
                  </div>
                  <div className={"accountDataContainerSmall"}>
                    <TextField
                    AppURL={Vas.ApplicationUrl}
                    Label={Vas.Resources.Labels["DateOfBirth"]}
                    ref={"DateOfBirth"} />
                  </div>
                </div>
                <div className={"accountDataContainer"}>
                  <div className={"accountDataContainerLarge"}>
                    <TextField
                    AppURL={Vas.ApplicationUrl}
                    Label={Vas.Resources.Labels["Street"]}
                    ref={"Street"} />
                  </div>
                  <div className={"accountDataContainerSmall"}>
                    <TextField
                    AppURL={Vas.ApplicationUrl}
                    Label={Vas.Resources.Labels["HouseNumber"]}
                    ref={"HouseNumber"} />
                  </div>
                </div>
                <div className={"accountDataContainer"}>
                  <div className={"accountDataContainerLarge"}>
                    <TextField
                    AppURL={Vas.ApplicationUrl}
                    Label={Vas.Resources.Labels["Zip"]}
                    ref={"Zip"} />
                  </div>
                  <div className={"accountDataContainerSmall"}>
                    <TextField
                    AppURL={Vas.ApplicationUrl}
                    Label={Vas.Resources.Labels["Place"]}
                    ref={"Place"} />
                  </div>
                </div>
                <div className={"accountDataContainer"}>
                  <div className={"accountChangePasswordButton"}>
                    <ExtendedButton
                    Id={"btoChangePassword"}
                    Usable={true}
                    Width={170}
                    className={"changePwdButton"}
                    Text={Vas.Resources.Labels["ChangePassword"]}
                    OnClick={()=>{ this.showChangePassword();}}  />
                  </div><div className={"accountDeletePasswordButton"}>
                    {button}
                  </div>
                </div>
            </div>
          </div>
        );
    }
}
export default Account;
